import type { CheckboxSchemaType } from '@vedalib/editor/lib/brand'
import React, { useCallback, useId } from 'react'

import type { ElementStyleCss } from 'services/Branding/types'
import { testPropsEl } from 'utils/test/qaData'

import CheckboxStyled from '../../styled/CheckboxStyled'
import LabelStyled from '../../styled/LabelStyled'
import MarkStyled from '../../styled/MarkStyled'

interface ICheckboxProps {
  disabled?: boolean
  checked: boolean
  onChange?: (value: boolean) => void
  setIsValid?: (value: boolean) => void
  styles: ElementStyleCss<CheckboxSchemaType>
  value: string
  testData: string
  isEditor?: boolean
  children: React.ReactNode
}

const Checkbox: React.FC<ICheckboxProps> = ({
  disabled,
  checked,
  onChange,
  setIsValid,
  children,
  styles,
  value,
  testData,
  isEditor,
}) => {
  const id = useId()
  const handleOnChange = useCallback(() => onChange?.(!checked), [checked, onChange])
  const handleSetIsValid = useCallback(() => {
    setIsValid?.(!checked)
  }, [checked, setIsValid])

  return (
    <CheckboxStyled
      {...testPropsEl('checkboxElement', { value }, { checked, testData })}
      $disabled={disabled}
      $styles={styles}
      htmlFor={id}
    >
      <input
        checked={checked}
        disabled={disabled}
        id={isEditor ? undefined : id}
        onChange={handleOnChange}
        type='checkbox'
      />
      <MarkStyled
        {...testPropsEl('checkmarkCheckbox', { value }, { checked, testData })}
        $checked={checked}
        $disabled={disabled}
        $styles={styles}
        onClick={isEditor ? handleSetIsValid : undefined}
      />
      <LabelStyled $disabled={disabled}>{children}</LabelStyled>
    </CheckboxStyled>
  )
}

export default React.memo(Checkbox)
